import Vue from "vue";
import Router from "vue-router";
import Homepage from "@/views/Homepage";
import SearchResults from "@/views/SearchResults";
import Address from "@/views/Address";
import Layers from "@/views/Layers";
import Layer from "@/views/Layer";
import Feature from "@/views/Feature";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Homepage",
      component: Homepage
    }, {
      path: "/search/:query",
      name: "SearchResults",
      component: SearchResults,
      props: true,
      meta: { layout: "content-with-map" }
    }, {
      path: "/address/:geohash([a-z0-9]*)-:slug",
      name: "Address",
      component: Address,
      props: true,
      meta: { layout: "content-with-map" }
    }, {
      path: "/layers",
      name: "Layers",
      component: Layers,
      meta: { layout: "content" }
    }, {
      path: "/layers/:uuid",
      name: "Layer",
      component: Layer,
      props: true,
      meta: { layout: "content-with-map" }
    }, {
      path: "/features/:uuid",
      name: "Feature",
      component: Feature,
      props: true,
      meta: { layout: "content-with-map" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js